import { motion } from "framer-motion";
import FleetCard from "@/components/FleetCard";

const FLEET = [
  {
    id: "sedan",
    name: "Executive Luxury Sedan",
    image: "/images/fleet-sedan.jpg",
    badge: "Signature Sedan",
    tagline: "Solo & Couples",
    passengers: "1–3 Passengers",
    luggage: "2 Bags",
    description:
      "Discreet, whisper-quiet transfers for solo executives and couples — Monterey Regional, SFO, and the private estates of Pebble Beach.",
    highlights: [
      "Late-model executive sedan",
      "Vetted professional chauffeur",
      "$1.5M commercially insured",
      "Flight tracking included",
    ],
  },
  {
    id: "suv",
    name: "Premium Luxury SUV",
    image: "/images/fleet-suv.jpg",
    badge: "Resort & Golf",
    tagline: "Family & Foursomes",
    passengers: "1–6 Passengers",
    luggage: "5 Bags",
    description:
      "The quintessential Peninsula vehicle — family parties and golf foursomes, with room for full luggage and a complete set of clubs.",
    highlights: [
      "Cargo bay fits four golf bags",
      "All-wheel coastal confidence",
      "Rear climate & heated seats",
      "Captain-chair second row",
    ],
  },
  {
    id: "jet-sprinter",
    name: "Jet Sprinter",
    image: "/images/fleet-jet-sprinter.jpg",
    badge: "The Private Jet Cabin",
    tagline: "Boardroom Intimacy",
    passengers: "1–8 Passengers",
    luggage: "10 Bags",
    description:
      "An intimate boardroom on wheels for up to eight — Maybach-style reclining captains, work desks, and a starlit canopy. The vehicle our C-suite guests ask for by name.",
    highlights: [
      "4 captain seats",
      "4 limo-style seats",
      "Wet bar",
      "Starlink Wi-Fi access",
    ],
  },
  {
    id: "executive-sprinter",
    name: "Executive Sprinter",
    image: "/images/fleet-executive-sprinter.jpg",
    badge: "The Grand Shuttle",
    tagline: "Group Capacity",
    passengers: "1–13 Passengers",
    luggage: "10 Bags",
    description:
      "High capacity without compromise — wedding parties, summit delegations, and tournament teams of up to thirteen, in a walk-in cabin with a dedicated luggage bay.",
    highlights: [
      "13 forward-facing leather seats",
      "High-ceiling walk-in cabin",
      "Dedicated luggage bay",
      "Multi-zone climate control",
    ],
  },
];

export default function FleetGrid() {
  return (
    <section id="fleet" data-testid="fleet-section" className="relative scroll-mt-20 py-24 sm:py-32">
      {/* Legacy anchor: old homepage links point at #sprinter — land guests on the Jet Sprinter card */}
      <span id="sprinter" className="absolute top-0" aria-hidden="true" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-14 flex flex-col gap-6 sm:mb-20 md:flex-row md:items-end md:justify-between"
        >
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-champagne">
              01 — The Fleet
            </p>
            <h2 className="mt-4 font-serif text-3xl font-light tracking-tight text-bone sm:text-5xl">
              Four vehicles. <span className="italic text-champagne">Every occasion.</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-smoke">
            From a single passenger to a party of thirteen — each vehicle is detailed before every
            dispatch and captained by a vetted professional chauffeur.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:gap-10" data-testid="fleet-grid">
          {FLEET.map((car, i) => (
            <FleetCard key={car.id} car={car} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
